<template>
    <section id="app-main-section" class="uk-section" uk-height-viewport="expand: true">
        <div id="app-main" class="uk-container">
            <router-view />
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            //
        }
    },
};
</script>

<style></style>
